import { SectionConfigBuilder } from '../ThemeConfigBuilder';
import { body, byline, headline, overline } from '../fields/fields';

export default new SectionConfigBuilder()
  .setContext('picker', {
    label: 'List',
    description: 'Content in traditional list or accordion ',
    icon: 'List',
  })
  .setContext('editor', {
    label: 'List Section',
    description: '',
    icon: 'List',
  })
  .addLayout('layout1', (layout) => {
    layout
      .setIcon('ListLayout1')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      })
      .setBlockVariants({
        label: 'Desktop List Data Placement',
        controlType: 'left right',
        options: [
          {
            value: 'variant1',
            label: 'Left',
          },
          {
            value: 'variant2',
            label: 'Right',
          },
        ],
      })
      .setBlockVariantsMobile({
        label: 'Mobile List Data Placement',
        controlType: 'top bottom',
        options: [
          {
            value: 'variant1',
            label: 'Top',
          },
          {
            value: 'variant2',
            label: 'Bottom',
          },
        ],
      });
  })
  .addLayout('layout2', (layout) => {
    layout
      .setIcon('ListLayout2')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(1);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      });
  })
  .addLayout('layout3', (layout) => {
    layout
      .setIcon('ListLayout3')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(3);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      })
      .setBlockVariants({
        label: 'Images Placement',
        controlType: 'top bottom',
        options: [
          {
            value: 'variant1',
            label: 'Top',
          },
          {
            value: 'variant2',
            label: 'Bottom',
          },
        ],
      });
  })
  .addLayout('layout4', (layout) => {
    layout
      .setIcon('ListLayout4')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      })
      .setBlockBodyMaxColumns(3);
  })
  .addLayout('layout5', (layout) => {
    layout
      .setIcon('ListLayout5')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      })
      .addBlock((block) => {
        block.setText([overline, headline, byline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(Infinity);
      });
  })
  .addLayout('layout6', (layout) => {
    layout
      .setDescription('List Data Only')
      .setIcon('ListLayout6')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(0);
      })
      .addBlock((block) => {
        block.setText([]);
        block.setMedia(0);
        block.setItems([overline, headline, byline, body]);
        block.setActions(0);
      });
  })
  .build();
